<template>
    <div class="c-o-my-pages-section">
        <div class="c-o-my-pages-section__inner">
            <div class="o-wysiwyg u-margin-bottom-2">
                <h2 class="c-o-my-pages-section__heading">Sökprofil</h2>
                <p>Nedan ser du de kategorier och regioner som används för att matcha dig mot anbudsförfrågningar.</p>
                <p>Om ni har frågor eller vill ändra dessa – kontakta vår kundtjänst (<a href="tel:07344160667">010 70 77 379</a> eller maila till <a href="mailto:byggare@brabyggare.se">byggare@brabyggare.se</a>).</p>
            </div>
            <div>
                <div class="c-m-tabs u-margin-bottom-3">
                    <div class="c-m-tabs__titles">
                        <div
                            class="c-m-tabs__title"
                            :class="{'c-m-tabs__title--active' : activeTab === 'categories'}"
                            @click="activeTab = 'categories'"
                        >
                            Kategorier
                        </div>
                        <div
                            class="c-m-tabs__title"
                            :class="{'c-m-tabs__title--active' : activeTab === 'regions'}"
                            @click="activeTab = 'regions'"
                        >
                            Regioner
                        </div>
                    </div>
                    <div class="c-m-tabs__contents">
                        <div v-show="activeTab === 'categories'" class="c-m-tabs__content">
                            <search-profile-categories
                                :metaCategories="metaData.categories"
                                :categories="searchProfile.Categories"
                                :company="company"
                                :user="user"
                                @updated="updateCategories($event)"
                                :disableEverything="false"
                            ></search-profile-categories>
                        </div>
                        <div v-show="activeTab === 'regions'" class="c-m-tabs__content">
                            <search-profile-regions
                                :metaRegions="metaData.regions"
                                :regions="searchProfile.Regions"
                                :company="company"
                                :user="user"
                                @updated="updateRegions($event)"
                                :disableEverything="false"
                            ></search-profile-regions>
                        </div>
                    </div>
                </div>
                <success-button class="c-a-button--theme-primary c-a-button--min-width" :currentState="saveState" @buttonClicked="save"></success-button> 
            </div>
        </div>
    </div>
</template>

<script>
    import { timeout } from '../../../../../../helpers';

    import {
        UPDATE_CATEGORIES,
        UPDATE_REGIONS,
        SAVE_SEARCH_PROFILE
    } from '../../../../../../store/store-models/search-profile-model';

    import SearchProfileCategories from '../../../../molecules/MoleculeSearchProfileCategories.vue';
    import SearchProfileRegions from '../../../../molecules/MoleculeSearchProfileRegions.vue';
    import SuccessButton from '../../../../atoms/AtomSuccessButton.vue';

    export default {
        data() {
            return {
                activeTab: 'categories',
                saveState: 'default'
            }
        },
        props: {
            metaData: {
                type: Object,
                default: () => ({
                    regions: [],
                    categories: {}
                })
            },
            searchProfile: {
                type: Object,
                default: () => ({
                    Regions: [],
                    Categories: []
                })
            },
            company: {
                type: Object
            },
            user: {
                type: Object
            }
        },
        components: {
            SearchProfileCategories,
            SearchProfileRegions,
            SuccessButton
        },
        methods: {
            updateCategories({payload, action}) {
                let categories = this.searchProfile.Categories;
                if (action === 'delete') {
                    payload.forEach(payloadCat => {
                        const index = categories.findIndex(cat => (payloadCat.Id === cat.Id));
                        if (index !== -1) {
                            categories.splice(index, 1);
                        }
                    });
                } else {
                    payload.forEach(payloadCat => {
                        const match = categories.find(cat => (payloadCat.id === cat.Id));
                        if (typeof match === 'undefined') {
                            categories.push(payloadCat)
                        }
                    });
                }
                this.$store.commit(UPDATE_CATEGORIES, categories);
            },
            updateRegions({payload, action}) {
                let regions = this.searchProfile.Regions;

                if (action === 'delete') {
                    payload.forEach(payloadReg => {
                        const index = regions.findIndex(reg => (payloadReg.Id === reg.Id));
                        if (index !== -1) {
                            regions.splice(index, 1);
                        }
                    });
                } else {
                    payload.forEach(payloadReg => {
                        const match = regions.find(reg => (payloadReg.Id === reg.Id));
                        if (typeof match === 'undefined') {
                            regions.push(payloadReg)
                        }
                    });
                }
                this.$store.commit(UPDATE_REGIONS, regions);

            },
            async save() {
                this.saveState = 'processing';
                try {
                    await this.$store.dispatch(SAVE_SEARCH_PROFILE);
                    this.saveState = 'success';
                } catch (error) {
                    this.saveState = 'error';
                }
                await timeout();
                this.saveState = 'default';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/search-profile/OrganismMyPagesSearchProfile.vue